var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0649 16.7141C13.6839 16.7141 14.2526 16.5875 14.7709 16.3343C15.2892 16.0812 15.7199 15.7279 16.063 15.2745C16.063 15.2745 16.4338 14.6521 16.0406 14.3694C15.6474 14.0868 15.1456 14.5377 15.1456 14.5377C14.6236 15.2178 13.93 15.5579 13.0649 15.5579C12.3042 15.5579 11.6628 15.2821 11.1408 14.7304C10.6187 14.1788 10.3577 13.5062 10.3577 12.7128C10.3577 11.9193 10.6187 11.2449 11.1408 10.6895C11.6628 10.1341 12.3042 9.85637 13.0649 9.85637C13.8703 9.85637 14.5565 10.1813 15.1233 10.8312C15.1233 10.8312 15.5386 11.293 15.9702 10.9607C16.4018 10.6285 16.0406 10.1057 16.0406 10.1057C15.6901 9.66745 15.2575 9.32362 14.7429 9.07425C14.2283 8.82488 13.669 8.7002 13.0649 8.7002C11.976 8.7002 11.055 9.09125 10.3017 9.87337C9.5485 10.6555 9.17188 11.602 9.17188 12.7128C9.17188 13.8236 9.5485 14.7682 10.3017 15.5465C11.055 16.3249 11.976 16.7141 13.0649 16.7141Z",
    fill: "#6CEFC2",
    stroke: "url(#paint0_linear_5221_15428)",
    strokeWidth: 1.88562
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23995 18.9063C7.23207 19.8984 8.34358 20.6097 9.57446 21.0404C10.8053 21.471 12.054 21.6029 13.3205 21.4361C13.3205 21.4361 14.8987 21.0466 14.7152 19.9697C14.5318 18.8927 13.0148 18.8013 13.0148 18.8013C11.1031 19.0396 9.45397 18.4654 8.06739 17.0788C6.84815 15.8596 6.25613 14.3956 6.29131 12.687C6.3265 10.9784 6.97115 9.49697 8.22528 8.24285C9.4794 6.98873 10.9638 6.34109 12.6784 6.29993C14.393 6.25877 15.8599 6.84781 17.0792 8.06705C18.3701 9.358 18.9562 10.9713 18.8375 12.9069C18.8375 12.9069 18.7733 14.3027 19.9902 14.4692C21.2071 14.6357 21.4544 13.2306 21.4544 13.2306C21.5853 11.976 21.4355 10.7393 21.0049 9.52033C20.5743 8.3014 19.8748 7.20783 18.9066 6.23961C17.1614 4.49443 15.0671 3.63631 12.6236 3.66523C10.1801 3.69416 8.08048 4.58651 6.3247 6.34228C4.56892 8.09805 3.67956 10.1947 3.65661 12.6322C3.63365 15.0697 4.49477 17.1611 6.23995 18.9063Z",
    fill: "url(#paint1_linear_5221_15428)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5221_15428",
    x1: 5.87501,
    y1: 11.5888,
    x2: 10.3691,
    y2: 18.0194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C47C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5221_15428",
    x1: -2.09609,
    y1: 16.2895,
    x2: 14.0063,
    y2: 20.9412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C47C6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth);
export default __webpack_public_path__ + "static/media/auth.d6e142d2d4f9641909434ff4509ed60f.svg";
export { ForwardRef as ReactComponent };